import { useEffect, useState } from "react";
const ProgressBar = ({
  label,
  value,
  value2 = 0,
  number = false,
  color = "#FF5C7A",
  icon,
}) => {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const t = requestAnimationFrame(() =>
      setWidth(Math.min(100, Math.max(0, value || 0))),
    );
    return () => cancelAnimationFrame(t);
  }, [value]);
  return (
    <div className="w-full min-w-[180px] flex-1">
      <div className="flex justify-between items-center mb-1.5 gap-2">
        <span className="flex items-center gap-1.5 text-sm text-slate-600 dark:text-white/75">
          {icon}
          {label}
        </span>
        <span className="font-['IBM_Plex_Mono',_monospace] text-xs font-semibold text-slate-900 dark:text-white tabular-nums">
          {number ? value2 : `${value ?? 0}%`}
        </span>
      </div>
      <div className="w-full h-2 rounded-full bg-black/[0.06] dark:bg-white/[0.06] overflow-hidden">
        <div
          className="h-full rounded-full"
          style={{
            width: `${width}%`,
            backgroundColor: color,
            boxShadow: `0 0 10px ${color}66`,
            transition: "width 900ms cubic-bezier(.22,1,.36,1)",
          }}
        />
      </div>
    </div>
  );
};
var ProgressBar_default = ProgressBar;
export { ProgressBar_default as default };
